import React, { useState } from "react";
import {
  Card,
  Button,
  Image,
  Form,
  Nav,
  Tab,
  InputGroup,
} from "react-bootstrap";
import { Search} from 'react-bootstrap-icons';
import {timelinemodal} from "../../../constants/jsonConstant";
import Livemodal from "../../../components/Timeline/Component/Modals/LiveModal/livemodal";
import Uploadpost from "../../../components/Timeline/Component/Modals/Upload_post/uploadpost";

import TimelineCard from "./TimelineCard";
const users = Array.from({ length: 10 }, (_, i) => ({
  name: "David Paul",
  img: `https://i.pravatar.cc/150?img=${i + 1}`,
}));

const Timeline = () => {
  const [key, setKey] = useState("myTimeline");
const [show,setShow]=useState('');
  const handleClose = () => setShow(0);

  return (

    <Card className="p-1 shadow">

{show === 2 && <Livemodal show={show} handleClose={handleClose} />}
      {show === 4 && (
        <Uploadpost
          show={show}
          handleClose={handleClose}
        />
      )}



      {/* Tabs */}
      <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="myTimeline">My Timeline</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="seekerTimeline">
              Investment Seeker Timeline
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="investorTimeline">Investor Timeline</Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content className="mt-3 p-3">
          <Tab.Pane eventKey={key}>
            {/* Search */}
            <InputGroup className="mb-3">
              <Form.Control placeholder="Search" />
              <Button variant="primary">
               <Search />
              </Button>
            </InputGroup>

            {/* Horizontal Scrollable Users */}
            <div className="d-flex overflow-auto mb-3">
              {users.map((user, idx) => (
                <div key={idx} className="text-center mx-2">
                  <Image src={user.img} roundedCircle width={60} height={60} />
                  <div style={{ fontSize: 11 }}>{user.name}</div>
                  <Button size="sm" variant="primary" className="mt-1 p-1 rounded" style={{ fontSize: 11 }}>
                    Connect
                  </Button>
                </div>
              ))}
            </div>

            {/* Post Actions */}
            <div className="d-flex justify-content-between flex-wrap mb-3">
             {timelinemodal.map((e) => (
            <div className="p-0" key={e.id}>
              <button
                className="btn font_small p-0 m-0"
                onClick={() => setShow(e?.id)}
              >
                <span style={{ color: e.color }}>{e.icon}</span> {e.text}
              </button>
            </div>
          ))}
            </div>

            {/* Timeline Posts */}
            <div
              className="timeline-posts"
              style={{ maxHeight:"71.5vh", overflowY: "auto" }}
            >
              <TimelineCard />
              <TimelineCard />
            </div>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Card>
  );
};

export default Timeline;
